import { Row, Col } from 'react-bootstrap'
import { faUsers, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from '~/i18n'

import SectionTitle from '~/components/shared/SectionTitle'
import EmailRelatedCard from '~/components/shared/EmailRelatedCard'
import CommentPanel from '~/components/shared/CommentPanel'
import AgendaItemRelatedCard from '~/components/shared/AgendaItemRelatedCard'

// TODO: add translations
const RelatedItemsDetails = ({
  commentsEnabled, comments, commentsReference, emails, agendaItems, className, t, onAuthRequire
}) => {
  const [messages, setMessages] = useState(comments)

  const hasEmails = !!emails.length
  const hasAgendaItems = !!agendaItems.length

  if (!commentsEnabled && !hasEmails && !hasAgendaItems) return null

  return (
    <div className={`border-top mt-3 pt-3 ${className}`}>
      <Row>
        {commentsEnabled && (
          <Col>
            <a id="comments">
              <CommentPanel
                messages={messages}
                onAuthRequire={onAuthRequire}
                onMessagesLoad={setMessages}
                reference={commentsReference}
              />
            </a>
          </Col>
        )}
        {(hasEmails || hasAgendaItems) && (
          <Col md={commentsEnabled ? 5 : 12}>
            <Row>
              {hasEmails && (
                <Col md={commentsEnabled ? 12 : 6}>
                  <a id="emails">
                    <SectionTitle title={t('relatedEmails')} icon={faEnvelope} />
                  </a>
                  {emails.map((email) => (
                    <EmailRelatedCard email={email} key={email.id} />
                  ))}
                </Col>
              )}
              {hasAgendaItems && (
                <Col md={commentsEnabled ? 12 : 6}>
                  <a id="relatedAgendaItems">
                    <SectionTitle title={t('relatedAgendaItems')} icon={faUsers} />
                  </a>
                  {agendaItems.map((agendaItem) => (
                    <AgendaItemRelatedCard agendaItem={agendaItem} key={agendaItem.id} />
                  ))}
                </Col>
              )}
            </Row>
          </Col>
        )}
      </Row>
    </div>
  )
}

RelatedItemsDetails.propTypes = {
  commentsEnabled: PropTypes.bool,
  commentsReference: PropTypes.object,
  className: PropTypes.string,
  agendaItems: PropTypes.arrayOf(PropTypes.object),
  comments: PropTypes.arrayOf(PropTypes.object),
  emails: PropTypes.arrayOf(PropTypes.object),
  t: PropTypes.func.isRequired,
  onAuthRequire: PropTypes.func.isRequired,
}

RelatedItemsDetails.defaultProps = {
  commentsEnabled: false,
  commentsReference: null,
  className: null,
  agendaItems: [],
  comments: [],
  emails: [],
}

export default withTranslation('relatedItemsDetails')(RelatedItemsDetails)
